import { PlaceholderPage } from './PlaceholderPage'

export default function AdminProjects() {
  return <PlaceholderPage title="Admin: Projects" route="/admin/projects" />
}
